module.exports = __webpack_public_path__ + "static/img/Blocks.62d055e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Blocks.gif
// module id = 244
// module chunks = 0 1 2 3 4 5 6 7 8 9